import React from 'react';

import Typeahead from '../Typeahead/Typeahead';

export const CREATE_API = '/api/school/create';
export const TYPEAHEAD_API = '/api/school/typeahead';

const formatSchoolResults = (school) => ({
    ...school,
    option: school.name,
});

const SchoolSelector = ({
    allowAddNewItem,
    inputMaxLength,
    setTypeaheadInput,
    handleError,
    handleSelect,
    items,
}) => (
    <Typeahead
        allowAddNewItem={allowAddNewItem}
        createNewItemApi={CREATE_API}
        fetchSuggestionsApi={TYPEAHEAD_API}
        inputMaxLength={inputMaxLength}
        isMulti={false}
        onChange={setTypeaheadInput}
        onError={handleError}
        onSelect={handleSelect}
        placeholderText="Start typing to select a school or add a new one"
        selectedSuggestions={items}
        setUserInput={formatSchoolResults}
        withTags={false}
        qaDataAttr="school"
    />
);

export default SchoolSelector;
